import React from "react";
import EDMR from "./EDMR";

const Service2 = () => {
  return <EDMR />;
};

export default Service2;